export enum MilestoneName {
  PROJECT_INITIATION = 'Project Initiation',
  TO_PROJECT_CONTROL_FOR_BIDDING = 'To Project Control For Bidding',
  RECOMMEND_AWARD = 'Recommend Award',
  NTP_ISSUE_DATE_C = 'NTP Issue Date (C)',
}
